module.exports = __webpack_public_path__ + "img/ebook-hero-thumb1.eda05155.png";